import { createContext,  useEffect, useState } from 'react';
import { Supplier, SuppliersResponse, SupplierResponse, CountriesResponse, Country, TypeService, TypeServiceResponse } from '../../models/interfaces';
import topApi from '../../components/api/ToPApi';




type SuppliersContextProps = {
    suppliers: Supplier[];
    totalPage: number;
    loadSuppliers: (page: number) => Promise<void>;
    loadTypeService:()=>Promise<TypeService[]>;
    addSupplier: ( supplier: Supplier, onCreated?: (supplier: Supplier) => void ) => Promise<string>;
    updateSupplier: ( supplier: Supplier ) => Promise<string>;
    deleteSupplier: ( id: number ) => Promise<string>;

}



export const SuppliersContext = createContext({} as SuppliersContextProps);

export const SuppliersProvider = ({ children }: any) => {

    const [suppliers, setSuppliers] = useState<Supplier[]>([]);      
    const [totalPage, setTotalPage] = useState<number>(0);
    const pageSize = 25;


    const loadSuppliers = async (pageActual) => {

        const resp = await topApi.get<SuppliersResponse>('/supplier/getSuppliers');
        if(resp.status == 200){
            setSuppliers([...resp.data.suppliers]);
            setTotalPage(1);
        }
    }

    
    const loadTypeService = async () => {

        const resp = await topApi.get<TypeServiceResponse>('/supplier/getTypeServices');
        if(resp.status == 200){
            return resp.data.services;
        }else{
            return [];
        }
    }

    const addSupplier = async (supplier: Supplier, onCreated?: (supplier: Supplier) => void)  => {
        try {
            supplier.supplierCode = undefined;
            const resp = await topApi.post<SupplierResponse>('/supplier/', { supplier });
            setSuppliers([...suppliers, resp.data.supplier]);
            onCreated?.(resp.data.supplier);
            return 'success'
            
        } catch (e) {
            const error = e.response?.data?.error;
            return error || "Ocurrió un error de comunicación, intente de nuevo.";
        }
    }
    

    const updateSupplier = async (supplier:Supplier) => {
        try {
            const resp = await topApi.put<Supplier>(`/supplier/${supplier.supplierCode}`, { supplier });
            
                setSuppliers(suppliers.map(prod => {    
                    return (prod.supplierCode === supplier.supplierCode)
                        ? resp.data["supplier"]
                        : prod;
                }));
            
            return 'success'
            
        } catch (e) {
            const error = e.response?.data?.error;
            return error || "Ocurrió un error de comunicación, intente de nuevo.";
        }
        
        
    }

    const deleteSupplier = async (id: number) => {
        try {
            await topApi.delete<Supplier>(`/supplier/${id}`);
            setSuppliers((prevSuppliers) =>
                prevSuppliers.filter((supplier) => supplier.supplierCode! !== id)
            );
            return 'success'
        } catch (e) {
            const error = e.response?.data?.error;
            return error || "Ocurrió un error de comunicación, intente de nuevo.";
        }       
    }

   

    return (
        <SuppliersContext.Provider value= {{ suppliers, totalPage, loadSuppliers, addSupplier, updateSupplier, deleteSupplier, loadTypeService}}>
            { children }
        </SuppliersContext.Provider>
    );
}